import React from 'react';
import FormItem from '@/components/molecules/formItem';
import Heading from '@/components/atoms/heading';
import Text from '@/components/atoms/text';
import Alert from '@/components/molecules/alert';
import Separator from '@/components/atoms/separator';
import AddressLookup from '@/components/molecules/addressLookup';
import { router, usePage } from '@inertiajs/react';
import { YES_NO_OPTIONS } from '@/lib/utils';
import BrokerSearchForm from '@/Portal/Quote/BrokerSearchForm';

export default ({ data, errors, showAlert, duplicateData, handleOnChange, hasDuplicates, handleOnBlur, setData }) => {
	const { accountType } = usePage().props.auth;
	const { policyType, broker } = usePage().props;
	const isEIS = accountType === 'eis';
	const isBroker = accountType === 'broker';
	const isGuest = accountType === 'guest';
	return (
		<div className="flex flex-col gap-8">
			{isGuest && !broker && (
				<div className="flex flex-col items-start gap-8 md:flex-row">
					<div className="flex flex-col gap-2 md:gap-6 shrink-0 md:basis-[26.466%]"></div>
					<div className="w-full space-y-8">
						<FormItem
							type="radiogroup"
							name="is_client_broker"
							label="Are you a broker?"
							value={data.is_client_broker}
							options={YES_NO_OPTIONS}
							isHorizontal={true}
							onChange={(value) => handleOnChange('is_client_broker', value)}
							validation="required"
							meta={{
								msg: errors?.is_client_broker,
								touched: errors?.is_client_broker ? true : false,
							}}
						/>
					</div>
				</div>
			)}
			{data.is_client_broker === 'yes' && (
				<>
					<Separator orientation="horizontal" />
					<BrokerSearchForm data={data} errors={errors} setData={setData} onlyShowForm={true} />
					<Separator orientation="horizontal" />
				</>
			)}
			<div className="flex flex-col items-start gap-8 md:flex-row">
				<div className="flex flex-col gap-2 md:gap-6 shrink-0 md:basis-[26.466%]">
					<Heading className="text-eis-black" type="h4">
						Insured Policy Holder Details
					</Heading>
					<Text type="p" variant="normal" className="text-formOutlineDark">
						Fields marked * are required to submit form
					</Text>
				</div>
				<div className="w-full space-y-8">
					{isGuest && !!broker && (
						<Alert
							type="info"
							title="Broker applied"
							description="Broker details have been applied."
							// priBtn="Continue"
							// priBtnOnClick={(e) => {
							// 	e.preventDefault();
							// 	router.visit(route('brokers.search', { policyName: policyType }));
							// }}
							// priBtnShowIcon={false}
							className="mt-10"
						/>
					)}

					<FormItem
						type="radiogroup"
						name="is_business"
						label="Is the insurance to be in the name of an organisation"
						value={data.is_business}
						options={YES_NO_OPTIONS}
						isHorizontal={true}
						onChange={(value) => handleOnChange('is_business', value)}
						validation="required"
						meta={{
							msg: errors?.is_business,
							touched: errors?.is_business ? true : false,
						}}
					/>

					{data.is_business === 'yes' && (
						<FormItem
							type="text"
							name="proposer_name"
							label="Organisation Name"
							placeholder="Organisation Name"
							value={data.proposer_name}
							onChange={(value) => handleOnChange('proposer_name', value)}
							onBlur={() => handleOnBlur('proposer_name')}
							autoComplete="proposer_name"
							validation="required"
							meta={{
								msg: errors?.proposer_name,
								touched: errors?.proposer_name ? true : false,
							}}
						/>
					)}

					<FormItem
						type="text"
						name="first_name"
						label={data.is_business === 'yes' ? 'Named Contact First Name' : 'First Name'}
						placeholder="First Name"
						value={data.first_name}
						onChange={(value) => handleOnChange('first_name', value)}
						onBlur={() => handleOnBlur('first_name')}
						autoComplete="first_name"
						validation="required"
						meta={{
							msg: errors?.first_name,
							touched: errors?.first_name ? true : false,
						}}
					/>

					<FormItem
						type="text"
						name="last_name"
						label={data.is_business === 'yes' ? 'Named Contact Surname' : 'Surname'}
						placeholder="Surname"
						value={data.last_name}
						onChange={(value) => handleOnChange('last_name', value)}
						onBlur={() => handleOnBlur('last_name')}
						autoComplete="last_name"
						validation="required"
						meta={{
							msg: errors?.last_name,
							touched: errors?.last_name ? true : false,
						}}
					/>

					<FormItem
						type="email"
						name="email"
						label="Email address"
						placeholder="Email address"
						value={data.email}
						onChange={(value) => handleOnChange('email', value)}
						onBlur={() => handleOnBlur('email')}
						autoComplete="email"
						validation="required"
						meta={{
							msg: errors?.email,
							touched: errors?.email ? true : false,
						}}
					/>

					<div className="flex flex-col gap-4">
						{isEIS ? (
							<AddressLookup
								postcodeField={{
									key: 'postcode_lookup',
									type: 'postcode_lookup',
									label: 'Postcode lookup',
								}}
								data={data}
								setData={setData}
								errors={errors}
								defaultFullAddress={{
									address_1: data.address_1,
									address_2: data.address_2,
									town: data.town,
									county: data.county,
									postcode: data.postcode,
								}}
							/>
						) : (
							<FormItem
								type="text"
								name="postcode"
								label="Postcode"
								placeholder="Postcode"
								value={data.postcode}
								onChange={(value) => setData('postcode', value)}
								onBlur={() => handleOnBlur('postcode')}
								autoComplete="postcode"
								meta={{
									msg: errors?.postcode,
									touched: errors?.postcode ? true : false,
								}}
							/>
						)}
						{isGuest && hasDuplicates && (
							<Alert type="success" title="Account exists" description="You already have an account - We have sent you a link to login." />
						)}
						{!isGuest &&
							showAlert &&
							(!duplicateData.length ? (
								<Alert
									type="success"
									title="No duplicates found"
									description="The CRM has not detected that duplicate entries are present. You can now proceed to set client up on the system."
								/>
							) : (
								<>
									<Alert
										type="error"
										title={`${duplicateData.length} duplicates found`}
										description="The CRM has detected that duplicate entries are present. Please browse the duplicate entries below using the dropdown list to confirm if a new entry needs to be created."
									/>

									<FormItem
										type="select"
										label="Browse duplicates"
										name="client_id"
										placeholder="Browse"
										options={duplicateData.map((duplicate) => ({
											label: `${duplicate.first_name} ${duplicate.last_name}, ${duplicate.postcode} ${duplicate.broker ? `(Broker: ${duplicate.broker.name})` : ''}`,
											value: duplicate.id.toString(),
										}))}
										value={parseInt(data.client_id).toString()}
										onChange={(value) => setData('client_id', value)}
										meta={{
											msg: errors?.client_id,
											touched: errors?.client_id ? true : false,
										}}
									/>

									{data.client_id && (
										<div className="pt-6">
											{duplicateData.map((duplicate) =>
												duplicate.id === parseInt(data.client_id) ? (
													<React.Fragment key={duplicate.id}>
														<Text type="p" variant="normal">
															{duplicate.name}
														</Text>
														<Text type="p" variant="normal">
															{duplicate.address_1}
														</Text>
														<Text type="p" variant="normal">
															{duplicate.town}
														</Text>
														<Text type="p" variant="normal">
															{duplicate.county}
														</Text>
														<Text type="p" variant="normal">
															{duplicate.postcode}
														</Text>
													</React.Fragment>
												) : null
											)}
										</div>
									)}
								</>
							))}
					</div>
				</div>
			</div>
		</div>
	);
};
